import React, { ElementType } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '../../utils/cn'
import IconCard from '../Icons/IconCard'
import IconManualBankTransfer from '../Icons/IconManualBankTransfer'
import { CheckoutPaymentMethod } from '../../services/payment/useCreateCheckout'

interface Props {
  formik: any
}

const PaymentMethodForm = ({ formik }: Props) => {
  const { t } = useTranslation()
  const handlePaymentMethod = (paymentMethod: CheckoutPaymentMethod) => {
    formik.setFieldValue('paymentMethod', paymentMethod)
  }
  return (
    <div className='flex flex-col'>
      <h2 className='text-[24px] font-bold'>{t('paymentInformation')}</h2>
      <p className='mb-7 text-lightGray'>
        {t('paymentInformationDescription')}
      </p>
      <div className='grid grid-cols-2 gap-5'>
        <PaymentMethod
          onClick={() => handlePaymentMethod('card')}
          isActive={formik.values.paymentMethod === 'card'}
          icon={IconCard}
          label={t('cardPayment')}
        />
        <PaymentMethod
          onClick={() => handlePaymentMethod('bank_transfer')}
          isActive={formik.values.paymentMethod === 'bank_transfer'}
          icon={IconManualBankTransfer}
          label={t('manualBankTransfer')}
        />
      </div>
    </div>
  )
}

export default PaymentMethodForm

function PaymentMethod({
  onClick,
  label,
  isActive,
  icon,
}: {
  onClick: () => void
  label: string
  isActive: boolean
  icon: ElementType<{ className?: string }>
}) {
  const Icon = icon
  return (
    <div
      className={cn(
        'border-[0.5px] gap-4 px-[30px] border-lightGray rounded-lg h-[125px] flex items-center cursor-pointer duration-300 transition-all',
        {
          'bg-primaryBlue': isActive,
        },
      )}
      onClick={onClick}
    >
      <Icon
        className={cn({
          'stroke-white': isActive,
        })}
      />
      <p
        className={cn(
          'text-lg font-semibold text-black duration-300 transition-colors',
          {
            'text-white': isActive,
          },
        )}
      >
        {label}
      </p>
    </div>
  )
}
